import { FC } from 'react'
import { NavLink, useSearchParams } from 'react-router-dom'

import { RenderIf } from 'components/RenderIf'
import { Button } from 'featureSliced/entities/Button'
import { getNavLink } from 'featureSliced/shared/utils/getNavLink'
import { useTranslations } from 'featureSliced/shared/hooks/useTranslations'
import { useMySelector } from 'featureSliced/shared/hooks/useMySelector'

type ButtonsCCProps = {
  handleLoyaltyButtonClick: () => void
}

export const ButtonsCC: FC<ButtonsCCProps> = ({ handleLoyaltyButtonClick }) => {
  const t = useTranslations()
  const [searchParams] = useSearchParams()
  const loginAvailable = useMySelector((state) => state.app.menu.loginAvailable)

  return (
    <RenderIf condition={process.env.REACT_APP_IS_CLIC === '1'}>
      <NavLink to={getNavLink(searchParams, 'menu')}>
        <Button buttonType="common">{t('cover.menu')}</Button>
      </NavLink>
      <RenderIf condition={loginAvailable}>
        <Button buttonType="stroke" onClick={handleLoyaltyButtonClick}>
          {t('profile.card')}
        </Button>
      </RenderIf>
    </RenderIf>
  )
}
